import apiClient from "./api";
const CAJAPAGOS_API_BASE_URL = "/cajaPagos";
class CajaPagosService {

  async getPagosPorCaja(cajaId) {
    try {
      const response = await apiClient.get(
        `${CAJAPAGOS_API_BASE_URL}/caja/${cajaId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async getReembolsosPorCaja(cajaId) {
    try {
      const response = await apiClient.get(
        `/reembolsos/caja/${cajaId}`,
      );
      return response.data;
    } catch (error) {
      console.warn("Endpoint reembolsos/caja no disponible:", error);
      return { estatus: "OK", reembolsos: [] };
    }
  }

}
export default new CajaPagosService();
